export const needsScheduling = (reminder) => reminder.tag && !reminder.tag.archived
  && (reminder.status === 'Unscheduled' || reminder.status === 'PastDue');

// allBarnHorses is fetched for the current lodging date with inactive=false.
// Use its explicit tag IDs; barnHorsesMap also contains unrelated horse/lodging keys.
export const getActiveHorseTagIds = (horses = []) => [...new Set(horses
  .filter((horse) => !horse.inactive)
  .map((horse) => Number(horse.pingumTagId))
  .filter((id) => Number.isSafeInteger(id) && id > 0))];

export const getPlannerReminderSummary = (reminders) => {
  const uniqueReminders = [...new Map(reminders.filter(needsScheduling).map((reminder) => [reminder.id, reminder])).values()];
  const tagIds = [...new Set(uniqueReminders.map((reminder) => reminder.tag.id))];
  return {
    reminders: uniqueReminders,
    reminderCount: uniqueReminders.length,
    horseCount: tagIds.length,
    tagIds,
  };
};

export const getPlannerReminderUrl = (tagIds, maxDueDate) => {
  const params = new URLSearchParams({
    tagIds: tagIds.join(','),
    maxDueDate,
    needsScheduling: 'true',
  });
  return `/tasks/reminders?${params}`;
};
